import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { RaceSportsPreview } from '@core/Areas/Racing/Hooks/RaceSportsContent/types'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { RaceSportsContent, getRaceSportsPreviews } from './api'

type UseRaceSportsContent = Pick<UseQueryResult, 'isLoading' | 'isError'> & {
  content?: {
    title: string
    racePreview: RaceSportsPreview
    tipsterProfilePictureUrl: MaybeDefined<string>
  }
}

export function useRaceSportsContent(
  meetingDate: Date,
  raceNumber: number,
  racecourseSeq?: number,
): UseRaceSportsContent {
  const queryKey = [queryKeys.meetingPreview, 'racing-sports', meetingDate, racecourseSeq]
  const { isLoading, isError, data } = useQuery<RaceSportsContent, Error>({
    queryKey: [queryKey],
    queryFn: () => getRaceSportsPreviews(meetingDate, racecourseSeq ?? 0),
    enabled: racecourseSeq !== undefined,
    staleTime: 1000 * 60 * 60, // 1hr12
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
  })
  const racePreview = data?.racePreviews.get(raceNumber)

  if (data === undefined || racePreview === undefined) {
    return { isLoading, isError }
  }

  return {
    isLoading,
    isError,
    content: {
      title: data.title,
      racePreview,
      tipsterProfilePictureUrl: data.tipsterProfilePictureUrl,
    },
  }
}
